import axios from 'axios'
export default {
  namespaced: true,
  state: {
    interfaceAdminShow: [],
    interfaceAdminLanguagesSelect: [],
  },
  mutations: {
    setInterfaceAdminShow(state, payload) {
      state.interfaceAdminShow = payload
    },
    setInterfaceAdminLanguagesSelect(state, payload) {
      state.interfaceAdminLanguagesSelect = payload
    },
  },
  getters: {
    interfaceAdminShow: (state) => state.interfaceAdminShow,
    interfaceAdminLanguagesSelect: (state) => state.interfaceAdminLanguagesSelect,
  },
  actions: {
    onInterfaceAdminShow({ commit, rootState }, { interface_group_id, language_id }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/interface/entity?interface_group_id=' +
            interface_group_id +
            '&interface_language_id=' +
            language_id,
          method: 'GET',
        })
          .then((resp) => {
            commit('setInterfaceAdminShow', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onInterfaceAdminUpdate({ commit, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/interface/entity',
          method: 'PUT',
          data,
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
